import { levenbergMarquardt } from 'ml-levenberg-marquardt';
import { Gaussian2D } from 'ml-peak-shape-generator';
const direction8X = [-1, -1, -1, 0, 0, 1, 1, 1];
const direction8Y = [-1, 0, 1, -1, 1, -1, 0, 1];
const direction16X = [-2, -2, -2, -2, -2, -1, -1, 0, 0, 1, 1, 2, 2, 2, 2, 2];
const direction16Y = [-2, -1, 0, 1, 2, -2, 2, -2, 2, -2, 2, -2, -1, 0, 1, 2];
export function determineRealTop(peaks, options) {
    const { nCols, absoluteData, originalData, minX, maxX, minY, maxY } = options;
    for (let i = 0; i < peaks.length; i++) {
        const xIndex = Math.round(peaks[i].x);
        const yIndex = Math.round(peaks[i].y);
        let currentIndex = xIndex + yIndex * nCols;
        const { index, isMax } = determineMax(absoluteData, {
            xIndex,
            yIndex,
            nCols,
            shell: 1,
        });
        currentIndex = isMax
            ? index
            : determineMax(absoluteData, {
                xIndex,
                yIndex,
                nCols,
                shell: 2,
            }).index;
        const realTopCoordinates = fitGaussian(originalData, {
            nCols,
            index: currentIndex,
            minY,
            maxY,
            minX,
            maxX,
        });
        peaks[i] = Object.assign(peaks[i], realTopCoordinates);
    }
    return peaks;
}
function determineMax(data, options) {
    const { xIndex, yIndex, shell, nCols } = options;
    let currentIndex = xIndex + yIndex * nCols;
    const [directionX, directionY] = shell > 1 ? [direction16X, direction16Y] : [direction8X, direction8Y];
    let isMax = false;
    for (let i = 0; i < directionX.length; i++) {
        const c = xIndex + directionX[i];
        const r = yIndex + directionY[i];
        if (data[c + r * nCols] >= data[currentIndex]) {
            isMax = true;
            const candidateIndex = c + r * nCols;
            for (let k = 0; k < direction8Y.length; k++) {
                const nc = c + direction8X[k];
                const nr = r + direction8Y[k];
                if (data[nc + nr * nCols] > data[candidateIndex]) {
                    isMax = false;
                    break;
                }
            }
            if (isMax) {
                currentIndex = candidateIndex;
            }
        }
    }
    return { index: currentIndex, isMax };
}
function fitGaussian(data, options) {
    const { nCols, index, minY, maxY, minX, maxX } = options;
    const nRows = data.length / nCols;
    const intervalX = (maxX - minX) / (nCols - 1);
    const intervalY = (maxY - minY) / (nRows - 1);
    const col = index % nCols;
    const row = (index - col) / nCols;
    const newCol = 1;
    const newRow = 1;
    let max = Number.MIN_SAFE_INTEGER;
    const z = new Array(direction8X.length + 1);
    const xAxis = new Array(direction8X.length + 1);
    for (let i = -1, xi = 0; i < 2; i++) {
        for (let j = -1; j < 2; j++, xAxis[xi] = xi++) {
            const value = data[col + j + (row + i) * nCols];
            if (max < value)
                max = value;
            z[newCol + j + (newRow + i) * 3] = value;
        }
    }
    for (let i = 0; i < z.length; i++)
        z[i] /= max;
    const maxValues = [newCol + 1, newRow + 1, 1.5, 1, 1];
    const minValues = [newCol - 1, newRow - 1, -1.5, 0.001, 0.001];
    const initialValues = [newCol, newRow, z[newCol + newRow * 3], 0.2, 0.2];
    const gradientDifference = [1e-4, 1e-4, 1e-3, 1e-3, 1e-3];
    const func = paramGaussian2D(intervalX, intervalY, 3);
    const pFit = levenbergMarquardt({ x: xAxis, y: z }, func, {
        damping: 1.5,
        maxIterations: 100,
        errorTolerance: 1e-8,
        initialValues,
        gradientDifference,
        maxValues,
        minValues,
    }).parameterValues;
    return {
        x: pFit[0] + col - 1,
        y: pFit[1] + row - 1,
        z: pFit[2] * max,
    };
}
function paramGaussian2D(intervalX, intervalY, nCols) {
    const gaussian2D = new Gaussian2D();
    return (p) => {
        return (t) => {
            const nL = p.length / 5;
            let result = 0;
            const xIndex = t % nCols;
            const yIndex = (t - xIndex) / nCols;
            for (let i = 0; i < nL; i++) {
                gaussian2D.fwhm = { x: p[i + 3 * nL], y: p[i + 4 * nL] };
                result +=
                    p[i + 2 * nL] *
                        gaussian2D.fct((xIndex - p[i]) * intervalX, (yIndex - p[i + nL]) * intervalY);
            }
            return result;
        };
    };
}
//# sourceMappingURL=determineRealTop.js.map